import type { SoluuDevice, WiFiStatus } from '@soluu/ble-core';

interface Props {
  device: SoluuDevice;
  status: WiFiStatus | null;
}

export function DeviceInfoPanel({ device, status }: Props) {
  return (
    <section className="section">
      <h2>Device</h2>
      <dl className="kv">
        <dt>Name</dt>
        <dd>{device.name || <span className="muted">(unnamed)</span>}</dd>
        <dt>Identifier</dt>
        <dd>{device.mac}</dd>
        <dt>Firmware</dt>
        <dd>{device.firmwareVersion || <span className="muted">unknown</span>}</dd>
        <dt>Radio firmware</dt>
        <dd>
          {device.radioFirmwareVersion || <span className="muted">unknown</span>}
        </dd>
        <dt>WiFi status</dt>
        <dd>
          {status ? (
            <span className={`label-pill label-${status.label}`}>{status.label}</span>
          ) : (
            <span className="muted">awaiting first notification…</span>
          )}
        </dd>
      </dl>
    </section>
  );
}
